module.exports = __webpack_public_path__ + "static/img/stamp_agree.205f0a42.png";